import TeamVersus from './TeamVersus'

export default TeamVersus
